<template>
  <div class="notification-container">
    <TransitionGroup name="fade-down" tag="div">
      <div
        v-for="n in notifications"
        :key="n.id"
        class="notification"
        :class="n.type"
      >
        <strong class="title" v-if="n.title">{{ n.title }}</strong>
        <p class="subtitle" v-if="n.message">{{ n.message }}</p>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'

const notifications = reactive([])

function addNotification(title, message, type = 'success', duration = 3000) {
  const id = Date.now() + Math.random()
  notifications.push({ id, title, message, type })

  setTimeout(() => {
    const index = notifications.findIndex(n => n.id === id)
    if (index !== -1) notifications.splice(index, 1)
  }, duration)
}

onMounted(() => {
  window.$notify = addNotification
})
</script>

<style scoped>
.notification-container {
  position: fixed;
  top: 30px;
  right: 30px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 320px;
}

.notification {
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  min-width: 240px;
  max-width: 100%;
}

.notification.success {
  background-color: #d4edda;
  color: #155724;
}
.notification.error {
  background-color: #f8d7da;
  color: #721c24;
}

.title {
  font-weight: 600;
  margin-bottom: 4px;
}

.subtitle {
  font-size: 0.9rem;
}

/* Transition animation */
.fade-down-enter-active,
.fade-down-leave-active {
  transition: all 0.3s ease;
}
.fade-down-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}
.fade-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
